import { ConfigEditor } from "./ConfigEditor.js";
import { ExecutionView } from "./ExecutionView.js";
import { Icon } from "./Icon.js";
import { configSchema, dataSchema, defaultConfig } from "./schema.js";
export const webhookWaitPlugin = {
    slug: "webhook-wait",
    name: "Webhook Wait",
    description: "Wait for an external webhook callback to complete the action",
    type: "automation",
    completionType: "external_webhook",
    configSchema,
    dataSchema,
    defaultConfig,
    handlers: {
        onStart: (ctx) => {
            ctx.logger.info("Webhook wait started", {
                actionId: ctx.execution.moduleActionId,
                timeoutMinutes: ctx.config.timeoutMinutes,
            });
            // In production, this might set up timeout monitoring
            return Promise.resolve();
        },
        onWebhook: (_ctx, payload) => {
            const webhookPayload = payload;
            return Promise.resolve({
                complete: true,
                data: {
                    webhookPayload,
                    receivedAt: new Date().toISOString(),
                },
            });
        },
    },
    components: {
        Icon,
        ConfigEditor,
        ExecutionView,
    },
    order: 5,
    version: "1.0.0",
    author: "Unios Team",
};
//# sourceMappingURL=index.js.map